import { P as t, c as r } from "./dev-D3SS6qhA.js";
const i = {
  _badVTTHeader() {
    return new t({
      code: r.BadSignature,
      reason: "missing WEBVTT file header",
      line: 1
    });
  },
  _badStartTimestamp(n, e) {
    return new t({
      code: r.BadTimestamp,
      reason: `cue start timestamp \`${n}\` is invalid on line ${e}`,
      line: e
    });
  },
  _badEndTimestamp(n, e) {
    return new t({
      code: r.BadTimestamp,
      reason: `cue end timestamp \`${n}\` is invalid on line ${e}`,
      line: e
    });
  },
  _badRangeTimestamp(n, e, a) {
    return new t({
      code: r.BadTimestamp,
      reason: `cue end timestamp \`${e}\` is greater than start \`${n}\` on line ${a}`,
      line: a
    });
  },
  _badCueSetting(n, e, a) {
    return new t({
      code: r.BadSettingValue,
      reason: `invalid value for cue setting \`${n}\` on line ${a} (value: ${e})`,
      line: a
    });
  },
  _unknownCueSetting(n, e, a) {
    return new t({
      code: r.UnknownSetting,
      reason: `unknown cue setting \`${n}\` on line ${a} (value: ${e})`,
      line: a
    });
  },
  _badRegionSetting(n, e, a) {
    return new t({
      code: r.BadSettingValue,
      reason: `invalid value for region setting \`${n}\` on line ${a} (value: ${e})`,
      line: a
    });
  },
  _unknownRegionSetting(n, e, a) {
    return new t({
      code: r.UnknownSetting,
      reason: `unknown region setting \`${n}\` on line ${a} (value: ${e})`,
      line: a
    });
  },
  // SSA-specific errors
  _missingFormat(n, e) {
    return new t({
      code: r.BadFormat,
      reason: `format missing for \`${n}\` block on line ${e}`,
      line: e
    });
  }
};
export {
  i as ParseErrorBuilder
};
